var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection4A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 37,
    viewBox: "0 0 82 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 81729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 2768",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 14.158H81H1Z",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3284",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52961 5.19398C5.92377 5.19398 6.2433 4.87445 6.2433 4.48029C6.2433 4.08613 5.92377 3.7666 5.52961 3.7666C5.13545 3.7666 4.81592 4.08613 4.81592 4.48029C4.81592 4.87445 5.13545 5.19398 5.52961 5.19398Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 16310",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.05908 2C1.05908 1.44772 1.45626 1 1.94621 1H81.0591V36.4983H1.05908V2Z",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3285",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52961 7.98451C5.92377 7.98451 6.2433 7.66498 6.2433 7.27082C6.2433 6.87666 5.92377 6.55713 5.52961 6.55713C5.13545 6.55713 4.81592 6.87666 4.81592 7.27082C4.81592 7.66498 5.13545 7.98451 5.52961 7.98451Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3286",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52961 10.7753C5.92377 10.7753 6.2433 10.4558 6.2433 10.0616C6.2433 9.66743 5.92377 9.3479 5.52961 9.3479C5.13545 9.3479 4.81592 9.66743 4.81592 10.0616C4.81592 10.4558 5.13545 10.7753 5.52961 10.7753Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3287",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46467 5.19398C8.85883 5.19398 9.17836 4.87445 9.17836 4.48029C9.17836 4.08613 8.85883 3.7666 8.46467 3.7666C8.07051 3.7666 7.75098 4.08613 7.75098 4.48029C7.75098 4.87445 8.07051 5.19398 8.46467 5.19398Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3288",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46467 7.98451C8.85883 7.98451 9.17836 7.66498 9.17836 7.27082C9.17836 6.87666 8.85883 6.55713 8.46467 6.55713C8.07051 6.55713 7.75098 6.87666 7.75098 7.27082C7.75098 7.66498 8.07051 7.98451 8.46467 7.98451Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3289",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46467 10.7753C8.85883 10.7753 9.17836 10.4558 9.17836 10.0616C9.17836 9.66743 8.85883 9.3479 8.46467 9.3479C8.07051 9.3479 7.75098 9.66743 7.75098 10.0616C7.75098 10.4558 8.07051 10.7753 8.46467 10.7753Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23994",
    x: 12.873,
    y: 2.96997,
    width: 30,
    height: 8,
    fill: "#C4C4C4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection4A);
export default __webpack_public_path__ + "static/media/Section4A.a9b38be94d26e08d769fbe86f1bf3c21.svg";
export { ForwardRef as ReactComponent };